/* tslint:disable:max-line-length */
import {ChangeDetectorRef, Component, EventEmitter, OnInit, Optional, Output, ViewChild} from '@angular/core';
import {HeaderToggleMenuEnum, MmFaultsSplitService} from '../services/mm-faults-split.service';
import {BehaviorSubject, combineLatest, filter, firstValueFrom, map} from 'rxjs';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {distinctUntilChanged, switchMap} from 'rxjs/operators';
import {FloatingActionButton, FloatingActionButtonService, FloatingActionItem, FloatingNewActionButtonComponent} from '@mydocma/component-library/src/lib/floating-action-button';
import {FloatButtonsTypesEnum, MmFaultsFabButtonService} from '../services/mm-faults-fab-button.service';
import {MmBimService} from '../../../mm-bim/mm-bim.service';
import {DeviceService} from '@mydocma/core/src/lib/device';
import {ProjectActionPermissionEnum} from '@docma-mm-core/permission/project-action-permission.enum';
import {MmProjectPermissionsService} from '../../../mm-project/mm-project-permissions-service';
import {MmTranslateService} from '../../../mm-translate.service';
import {ConnectivityService} from '@mydocma/core';
import {MmBimDialogService} from '../../../mm-bim/mm-bim-view/bim-dialog/bim-dialog.service';
import {PromptDialogService} from '@mydocma/component-library/src/lib/prompt-dialog';
import {MmFaultsViewService} from '../services/mm-faults-view.service';
import {SelectionService} from '@mydocma/component-library/src/lib/selection';
import {ViewFault} from '@docma-mm-core/fault/fault';
import {MmPlansManagerService} from '../../mm-plans-view/services/mm-plans-manager.service';
import {MmPlanEditService} from '../../mm-plans-view/mm-plan-view/services/mm-plan-edit.service';
import {MmProjectLoaderService} from '../../../mm-project/mm-project-loader.service';
import {MmFilterService} from '../../../mm-filter/mm-filter.service';
import {AppContainerService, AppLeftPaneService, SideNavBarService} from '@mydocma/app-container';
import {MmViewService} from '../../../mm-view.service';
import {MmFilterModel} from '../../../mm-filter/mm-filter.model';
import {MmPlanMobileViewService} from '../../mm-plans-view/services/mm-plan-mobile-view.service';
import {MmPlanViewService} from '../../mm-plans-view/mm-plan-view/services/mm-plan-view.service';
import {ColDefsService} from '../../mm-faults-ag-grid/col-defs/col-defs.service';
import {RowDefsService} from '../../mm-faults-ag-grid/row-defs/row-defs.service';
import {ChipListOptions} from '@mydocma/component-library/src/lib/chips/chip-list/chip-list-options';
import {ToggleGroupItem} from '@mydocma/component-library/src/lib/toggle-group/models/toggle-group-item';
import {ChipItem, ChipListStartAddNewEnum, ChipListViewTypeEnum} from '@mydocma/component-library/src/lib/chips';
import {MmPlansFilterService} from '../../mm-plans-view/services/mm-plans-filter.service';
import {BimModelAvailabilityService} from '../../../mm-bim/bim-model-availability.service';
import {MmFaultActionsService} from '../../mm-fault-actions.service';
import {MatMenu} from '@angular/material/menu';
import {MmFaultsSortingService, SortCriterionEnum, SortDirectionEnum, SortSourceEnum, TileSortState} from '../services/mm-faults-sorting.service';
import {MmLayoutStateService} from '../../../mm-filter/layout/layout-state.service';
import {LayoutEditService} from '../../../mm-filter/layout/layout-edit/layout-edit-service';
import {LayoutStateModel} from '../../../mm-filter/layout/layout-state.model';
import {LayoutSortItem} from '@docma-mm-core/layout/layout-sort-item';
import {SortDirectionEnum as CoreSortDirectionEnum} from '@docma-mm-core/sorting/sort-direction.enum';
import {Field} from '@docma-mm-core/field/field';
import {FieldPermission} from '@docma-mm-core/field/field-permission.enum';
import {LoadStatusEnum} from '@docma-mm-core/model/load-state/load-state.enum';
import {FaultSyncService} from '@docma-mm-core/fault/sync/fault-sync.service';
import {PlatformModeStateService} from '../../../mm-offline/services/platform-mode-state.service';
import {NotificationService} from '@mydocma/component-library/src/lib/notification';
import {MatLegacyDialog as MatDialog} from '@angular/material/legacy-dialog';
import {MmFaultsImportDialogComponent} from '../../mm-faults-import/mm-faults-import-dialog.component';
import {ArchiveSettings} from '@mydocma/core/src/lib/archive';

enum ToggleItemsGroupEnum {
  First= 'first',
  Second= 'second',
  Third= 'third'
}

enum ToggleItemsIdEnum {
  GridView = 'gridView',
  TileView = 'tileView',
  PlanView = 'planView',
  BimView = 'bimView'
}

@UntilDestroy()
@Component({
  selector: 'mydocma-mm-faults-view-header',
  templateUrl: './mm-faults-view-header.component.html',
  styleUrls: ['./mm-faults-view-header.component.scss'],
  providers: []
})
export class MmFaultsViewHeaderComponent implements OnInit {
  public static mmCreateFromDescription = 'mm-create-from-desc';
  public static mmCreateFromFile = 'mm-create-from-file';
  public static mmCreateFromPlan = 'mm-create-from-plan';
  public static mmCreateFromBim = 'mm-create-from-bim';
  public static mmCreateFromImport = 'mm-create-from-import';

  private static readonly MULTILINE_DROPDOWN_CLASS = 'multiline-dropdown';
  private static readonly SORTING_DROPDOWN_CLASS = 'sorting-dropdown';
  private static readonly MENU_MARGIN_STYLE = 'margin-left: 4px; margin-right: 4px;';

  @ViewChild('ref', { static: false }) floatingButton: FloatingNewActionButtonComponent;
  public toggleItemsGroupEnum = ToggleItemsGroupEnum;
  public headerToggleMenuEnum = HeaderToggleMenuEnum;
  permissionNewFault$ = this.permissionService.hasProjectActionPermissions([ProjectActionPermissionEnum.NewFault]);
  fabButtonSubject = new BehaviorSubject<FloatingActionButton>(null);
  fabButton$ = this.fabButtonSubject.asObservable();
  permissionDeleteAttachment$ = this.permissionService.hasProjectActionPermissions([ProjectActionPermissionEnum.DeleteAttachment]);
  permissionAddAttachment$ = this.permissionService.hasProjectActionPermissions([ProjectActionPermissionEnum.AddAttachment]);
  permissionMultiSelect$ = this.permissionService.hasProjectActionPermissions([ProjectActionPermissionEnum.EditFault, ProjectActionPermissionEnum.DeleteFault]);
  filterState: MmFilterModel;
  offline = false;
  @Output() onRefreshFaultsClicked = new EventEmitter();
  showTabletMeatballMenu = false;
  showStroke = !this.deviceService.isMobil();

  @ViewChild('gridMultilineDropdown') gridMultilineMatMenuRef: MatMenu;

  sortCriterionEnum = SortCriterionEnum;
  sortDirectionEnum = SortDirectionEnum;
  currentSortState: TileSortState;
  availableCriteria: SortCriterionEnum[] = [];
  currentLayoutState: LayoutStateModel;
  hasLayoutSorting = false;
  private pendingSortToApply: TileSortState | null = null;
  isMobile = false;
  fieldPermDict: { [prop: string]: FieldPermission } = {};

  gridViewToggleItem: ToggleGroupItem;
  tileViewToggleItem: ToggleGroupItem;
  planViewToggleItem: ToggleGroupItem;
  bimViewToggleItem: ToggleGroupItem;
  toggleGroupItems1: ToggleGroupItem[];
  toggleGroupItems2: ToggleGroupItem[];
  toggleGroupItems3: ToggleGroupItem[];
  selectedItem1: ToggleGroupItem;
  selectedItem2: ToggleGroupItem;
  selectedItem3: ToggleGroupItem;

  currentStructureChipOptions: ChipListOptions = {
    hideRemoveAll: true,
    viewType: ChipListViewTypeEnum.singleLine,
    addNewOptions: {
      startAdding: ChipListStartAddNewEnum.none,
      allowDuplication: false,
    },
    onChipRemove: async () => {
      this.filterService.setStructure(this.filterState.project.Structure);
    }
  };
  private currentStructureSubject = new BehaviorSubject<ChipItem[]>([]);
  public currentStructure$ = this.currentStructureSubject.asObservable();

  constructor(readonly faultsSplitService: MmFaultsSplitService,
              public readonly permissionService: MmProjectPermissionsService,
              public mmBimService: MmBimService,
              public connectivityService: ConnectivityService,
              public readonly bimDialogService: MmBimDialogService,
              public fabButtonService: MmFaultsFabButtonService,
              private appLeftPaneService: AppLeftPaneService,
              private sideNavBarService: SideNavBarService,
              private mmViewService: MmViewService,
              private readonly projectLoaderService: MmProjectLoaderService,
              public readonly selectionService: SelectionService<ViewFault>,
              private readonly planEditService: MmPlanEditService,
              public readonly viewService: MmFaultsViewService,
              private translateService: MmTranslateService,
              private readonly filterService: MmFilterService,
              private readonly dialogService: PromptDialogService,
              private readonly plansManagerService: MmPlansManagerService,
              private fabService: FloatingActionButtonService,
              private mmPlanViewService: MmPlanViewService,
              private appContainerService: AppContainerService,
              private mobilePlanViewService: MmPlanMobileViewService,
              public deviceService: DeviceService,
              public colDefsService: ColDefsService,
              public rowDefsService: RowDefsService,
              public modelAvailabilityService: BimModelAvailabilityService,
              private readonly plansFilterService: MmPlansFilterService,
              private readonly faultActionsService: MmFaultActionsService,
              private readonly faultSyncService: FaultSyncService,
              private readonly sortingService: MmFaultsSortingService,
              private readonly layoutStateService: MmLayoutStateService,
              private readonly layoutEditService: LayoutEditService,
              private readonly cdr: ChangeDetectorRef,
              public platformModeStateService: PlatformModeStateService,
              private readonly notificationService: NotificationService,
              public dialog: MatDialog,
              @Optional() private readonly archiveSetting: ArchiveSettings) {

      this.faultsSplitService.toggledLeftViews$
        .pipe(untilDestroyed(this))
        .subscribe(views => {
        this.faultsSplitService.toggledLeftViews = views;
        this.syncLeftViewItemsWithToggleItems();
      });

      this.faultActionsService.closePlanView
        .pipe(untilDestroyed(this))
        .subscribe(() => {
          this.selectedItem2 = null;
          if (this.toggleGroupItems1.find(x => x.id === ToggleItemsIdEnum.PlanView && this.deviceService.isTablet)){
            if (this.faultsSplitService.toggledLeftViews?.includes(ToggleItemsIdEnum.GridView)){
              this.selectedItem1 = this.toggleGroupItems1.find(x => x.id === ToggleItemsIdEnum.GridView);
            }else if (this.faultsSplitService.toggledLeftViews?.includes(ToggleItemsIdEnum.TileView)){
              this.selectedItem1 = this.toggleGroupItems1.find(x => x.id === ToggleItemsIdEnum.TileView);
            }
          }
        });

      this.faultsSplitService.toggledRightViews$
        .pipe(untilDestroyed(this))
        .subscribe(toggledRightViews => {
          this.initGroupToggleItems();

          if (toggledRightViews?.includes('planView')) {
            this.selectedItem2 = this.toggleGroupItems2?.find(x => x.id === ToggleItemsIdEnum.PlanView);
          } else {
            this.selectedItem2 = null;
          }
        });
  }

  ngOnInit(): void {
    this.isMobile = this.deviceService.isMobil();

    this.fabService.onFabButtonItemClick
      .pipe(untilDestroyed(this))
      .subscribe(value => {
        this.onFabItemClick(value);
      });
    this.connectivityService.appIsInOfflineMode
      .pipe(
        untilDestroyed(this),
        switchMap(o => {
          this.onOfflineChanged(o);
          return this.filterService.state;
        }),
      ).subscribe((fs) => {
      this.filterState = fs;
    });

    this.platformModeStateService.isLocalMode$
      .pipe(untilDestroyed(this))
      .subscribe(async lm => {
        await this.onLocalModeChanged(lm);
      });

    this.platformModeStateService.isLocalMode$
      .pipe(untilDestroyed(this))
      .subscribe(async lm => {
        await this.onLocalModeChanged(lm);
      });

    combineLatest([
      this.permissionNewFault$,
      this.permissionAddAttachment$,
      this.modelAvailabilityService.isBimIntegrationEnabled$,
      this.faultsSplitService.rightViewVisible$.pipe(untilDestroyed(this), distinctUntilChanged()),
      this.mobilePlanViewService.activated$,
      this.mmPlanViewService.isFaultTileVisibleSubject
    ])
      .pipe(
        untilDestroyed(this),
      )
      .subscribe(([permissionNewFault, permissionAddAttachment, bimModel, rightViewVisibility, mobilPlanActivated, isFaultTileVisible]) => {
        this.onPlanViewClose(rightViewVisibility);
        let fabButton: FloatingActionButton = null;
        if (permissionNewFault) {
          if (mobilPlanActivated) {
            fabButton = {
              id: FloatButtonsTypesEnum.planView,
              floatingDisabled: false,
              iconName: 'add',
              tooltip: 'MM.fault.createFaultFromPlan',
            };

            if (isFaultTileVisible) {
              fabButton.class = 'mydocma-mm-fab-planview-button';
            } else {
              fabButton.class = '';
            }
          } else {
            fabButton = this.getFabButton(permissionAddAttachment, bimModel);
          }
        }
        if (fabButton) {
          this.translateFabButton(fabButton);
          this.fabButtonService.registerButton(fabButton);
        } else {
          this.fabButtonService.unregisterButton();
        }
        this.fabButtonSubject.next(fabButton);

      });

    this.translateService.onLangChange.pipe(untilDestroyed(this)).subscribe(value => {
      this.translateFabButton(this.fabButtonSubject.value);
      setTimeout(() => this.initGroupToggleItems(), 0);
    });

    this.filterService.state
      .pipe(untilDestroyed(this))
      .subscribe(state => {
        if (state.structure) {
          const currentStructureChip = {
            id: 'currentStructure',
            text: `${state.structure?.Name1}${(state.structure?.Name2 && this.showStroke ? (' - ' + state.structure?.Name2) : '')}`,
            // tooltip: (this.translateService.instant('MM.fault.projectStructure')) + ` ${this.filterState.structure.Name1} - ${this.filterState.structure.Name2}`,
            iconName: this.showStroke ? '_stacked-organizational-chart-highlighted-first-node' : null,
          };
          this.currentStructureSubject.next([currentStructureChip]);
        } else if (this.currentStructureSubject.value.length === 0) {
          this.currentStructureSubject.next([]);
        }
      });

    setTimeout(() => {
        this.initGroupToggleItems();
        this.syncLeftViewItemsWithToggleItems();
      }, 0);

    this.sortingService.sortState$
      .pipe(untilDestroyed(this))
      .subscribe(state => {
        console.warn('[Header] Sort state changed:', state);
        this.currentSortState = state;

        this.cdr.detectChanges();

        const isClientSideOnly = state.criterion === SortCriterionEnum.Selected ||
                                  state.criterion === SortCriterionEnum.List;

        const isNoSorting = state.criterion === null && state.source === SortSourceEnum.Grid;

        const isGridListSort = state.source === SortSourceEnum.Grid && state.criterion === SortCriterionEnum.List;

        const shouldApplyToServer =
          state.criterion != null &&
          !isClientSideOnly &&
          ((state.source === SortSourceEnum.Default && state.criterion !== SortCriterionEnum.List) ||
           state.source === SortSourceEnum.Grid);

        if (isNoSorting) {
          setTimeout(async () => {
            await this.sortingService.saveSortState(state);
            await this.clearServerSort();
          }, 0);
        } else if (shouldApplyToServer) {
          console.log('[Header] Applying sort state to server:', state);
          setTimeout(async () => {
            if (state.source === SortSourceEnum.Grid) {
              await this.sortingService.saveSortState(state);
            }
            if (!this.currentLayoutState?.layout?.Fields?.length) {
              this.pendingSortToApply = state;
              return;
            }
            await this.applySortToServer(state.criterion, state.direction);
          }, 0);
        } else if (isGridListSort) {
          setTimeout(async () => {
            await this.sortingService.saveSortState(state);
          }, 0);
        } else if (isClientSideOnly) {
          console.log('[Header] Client-side sorting (Selected/List) - no API call');
        }
      });

    combineLatest([
      this.layoutStateService.currentLayoutState$,
      this.permissionMultiSelect$,
      this.projectLoaderService.fields.pipe(
        filter(userPerm => userPerm.loadState.status == LoadStatusEnum.Loaded),
        map(m => Object.fromEntries(
          m.data
            .filter(x => x.Prop != null)
            .map(x => [x.Prop.toString(), x.Permission])
        ))
      )
    ])
      .pipe(untilDestroyed(this))
      .subscribe(async ([layoutState, hasMultiSelectPermission, fieldPermDict]) => {
        this.currentLayoutState = layoutState.state;
        this.fieldPermDict = fieldPermDict as any;
        this.availableCriteria = this.sortingService.getAvailableCriteria(layoutState.state, this.fieldPermDict);

        const { sortedFields } = this.sortingService.getLayoutDefaultSorting(layoutState.state);
        this.hasLayoutSorting = sortedFields.length > 0;

        if (!hasMultiSelectPermission) {
          this.availableCriteria = this.availableCriteria.filter(c => c !== SortCriterionEnum.Selected);
        }

        if (this.isMobile) {
          this.availableCriteria = this.availableCriteria.filter(c => c !== SortCriterionEnum.List);
        }

        this.sortingService.syncFromLayoutState(layoutState.state);
        this.cdr.detectChanges();

        if (this.pendingSortToApply && this.currentLayoutState?.layout?.Fields?.length) {
          const pending = this.pendingSortToApply;
          this.pendingSortToApply = null;
          await this.applySortToServer(pending.criterion, pending.direction);
        }
      });

    this.layoutEditService.layoutChanged$
      .pipe(untilDestroyed(this))
      .subscribe(({ Layout }) => {
        if (Layout?.Id === this.currentLayoutState?.layout?.Id) {
          const hasSorting = Layout.LayoutFields?.some(lf => lf.Sorting && lf.Sorting !== 0) ?? false;
          this.hasLayoutSorting = hasSorting;

          if (this.currentLayoutState?.layout) {
            this.currentLayoutState.layout.Fields = Layout.LayoutFields?.map(lf => ({
              ...lf,
              Field: lf.Field,
              Sorting: lf.Sorting,
              IsDescending: lf.IsDescending
            })) as any;
          }

          this.cdr.detectChanges();
        }
      });
  }

  public async emitRefreshFaults() {
    const currentState = this.sortingService.getCurrentSortState();
    const selectionMode = await firstValueFrom(this.selectionService.selectionMode);

    if (currentState?.criterion === SortCriterionEnum.Selected && selectionMode) {
      console.log('[Header] Refreshing Selected sort only (selection mode active) - no data refetch needed');
      this.sortingService.refreshSelectedSort();
      return;
    }

    console.log('[Header] Performing full data refresh from server');
    this.onRefreshFaultsClicked.emit(true);
    // const result = await this.faultSyncService.syncAll();
    // console.warn('faultSyncService.syncAll', result);
  }

  async toggleSelectionMode() {
    this.selectionService.toggleSelectionMode();

    const selectionMode = await firstValueFrom(this.selectionService.selectionMode);

    if (selectionMode) {
      const currentFault = await firstValueFrom(this.viewService.currentFault);
      if (currentFault) {
        this.selectionService.selectItem(currentFault, true);
      }
    } else {
      const selectedItems = await firstValueFrom(this.selectionService.selectedItems);
      if (selectedItems && selectedItems.length > 0) {
        this.selectionService.deselectRange(selectedItems, false);
      }
    }
  }

  // this method listens to button or sub item click, depends on item type fire additional methods
  async onFabItemClick(btn: FloatingActionItem) {
    switch (btn.id) {
      case MmFaultsViewHeaderComponent.mmCreateFromDescription:
        await this.stopSelectionMode();
        await this.viewService.createFaultFromDescription();
        break;
      case MmFaultsViewHeaderComponent.mmCreateFromFile:
        await this.stopSelectionMode();
        await this.viewService.createFaultFromAttachments();
        break;
      case MmFaultsViewHeaderComponent.mmCreateFromPlan:
        await this.stopSelectionMode();
        if (this.appContainerService.isMobileView){
          await this.plansManagerService.setSelectedPlan(null);
        }
        await this.createFaultFromPlan();
        break;
      case FloatButtonsTypesEnum.planView:
        await this.stopSelectionMode();
        await this.createFaultFromPlan();
        break;
      case MmFaultsViewHeaderComponent.mmCreateFromBim:
        await this.stopSelectionMode();
        this.bimDialogService.openBimDialog(true);
        break;
      case FloatButtonsTypesEnum.faultsView:
        await this.stopSelectionMode();
        await this.onFabButtonClick();
        break;
      case MmFaultsViewHeaderComponent.mmCreateFromImport:
        this.openFaultsImportDialog();
        break;
      case FloatButtonsTypesEnum.activities:
      case FloatButtonsTypesEnum.attachments:
        break;
      default:
        await this.stopSelectionMode();
        break;
    }
  }

  async openFaultsImportDialog() {
    const dialogRef = this.dialog.open(MmFaultsImportDialogComponent, {
      data: {
        config: null, service: this
      },
      panelClass: ['mydocma-dialog', 'mydocma-dialog-xs-fullscreen', 'mydocma-mm-faults-import-dialog'],
      autoFocus: false,
      disableClose: true });

    dialogRef.afterClosed().subscribe(async r => {
      if (!r) {
        // if (reportConfig?.preparation) {
        //   try {
        //     await this.deleteWritingPreparation(reportConfig.preparation);
        //   } catch (err) {
        //     this.notificationService.warning(`Can't delete writing preparation ${reportConfig.preparation.FileGroupId}`);
        //   }
        // }
      }
    });
  }

  async createFaultFromPlan() {

    if (this.faultsSplitService.toggledRightViews.includes('planView') && this.plansManagerService.selectedPlan == null && (this.plansFilterService.filteredPlans?.length ?? 0) === 0) {
      this.dialogService.showNotificationDialog({
        title: this.translateService.instant('MM.plan.error.pinNotPossible'),
        subTitle: this.translateService.instant('MM.plan.error.noPlansOnStructure'),
        content: this.plansManagerService.allPlans.length === 0 ? this.translateService.instant('MM.plan.error.noPlansInProject')
          : this.translateService.instant('MM.plan.error.newFaultNoPlans.changeStructure')
      });
      return;
    } else if (!this.faultsSplitService.toggledRightViews.includes('planView') && !this.deviceService.isMobil()) {
      const planList = this.plansFilterService.filteredPlans;
      if (planList?.length === 0) {
        if (this.plansManagerService.allPlans.length > 0) {
          this.dialogService.showNotificationDialog({
            title: this.translateService.instant('MM.plan.error.pinNotPossible'),
            subTitle: this.translateService.instant('MM.plan.error.noPlansOnStructure'),
            content: this.translateService.instant('MM.plan.error.newFaultNoPlans.changeStructure')
          });
          return;
        } else if (this.plansManagerService.allPlans.length === 0) {
          this.dialogService.showNotificationDialog({
            title: this.translateService.instant('MM.plan.error.pinNotPossible'),
            content: this.translateService.instant('MM.plan.error.noPlansInProject')
          });
          return;
        }

      } else if (planList?.length === 1) {
        await this.plansManagerService.setSelectedPlan(planList[0]);
      } else {
        await this.plansManagerService.setSelectedPlan(null);
      }
    } else if (!this.plansManagerService.checkFaultInPlanStructure(this.filterState?.structure?.Id, this.plansManagerService.selectedPlan?.data?.Structure?.Id)) {
      this.dialogService.showNotificationDialog({
        title: this.translateService.instant('MM.plan.error.pinNotPossible'),
        subTitle: this.translateService.instant('MM.plan.error.faultPlanStructureInvalid'),
        content: this.translateService.instant('MM.plan.error.selectAnotherPlan'),
      });
      return;
    }
    // close sidenav bar for when we create from plan in tablet
    // might not work correctly for android tablets, cos device service will identity them as mobile device
    if (this.deviceService.isTablet()) {
      this.sideNavBarService.closeBar();
    }

    await this.viewService.createFaultFromDescription(MmFaultsViewHeaderComponent.mmCreateFromPlan);
    await this.planEditService.addFaultOnPin();


    // this.faultsSplitService.switchToPlanView(sender);
  }

  onResize($event) {
    setTimeout(() => {
      this.showTabletMeatballMenu = !this.deviceService.isMobil() && $event.contentRect.width - (document?.getElementsByClassName('structure-chiplist')[0]?.clientWidth || 0) < 450;
      this.showStroke = $event.contentRect.width > 350 && !this.deviceService.isMobil();
    }, 50);
  }

  onSubMenuOpened() {
    this.applyMenuMargins(MmFaultsViewHeaderComponent.MULTILINE_DROPDOWN_CLASS);
    return this.showTabletMeatballMenu;
  }

  onSortMenuOpened() {
    this.applyMenuMargins(MmFaultsViewHeaderComponent.SORTING_DROPDOWN_CLASS);
  }

  private applyMenuMargins(className: string): void {
    const element = document.getElementsByClassName(className)[0]?.parentElement;
    if (element) {
      element.setAttribute('style', MmFaultsViewHeaderComponent.MENU_MARGIN_STYLE);
    }
  }

  async onSortCriterionClick(criterion: SortCriterionEnum): Promise<void> {
    const direction = this.currentSortState?.direction || SortDirectionEnum.Ascending;
    console.log('[onSortCriterionClick]:', criterion, direction);

    if (criterion === SortCriterionEnum.Selected && this.currentSortState?.criterion === criterion) {
      this.sortingService.refreshSelectedSort();
    } else if (criterion === SortCriterionEnum.List) {
      await this.applyLayoutDefaultSorting();
    } else {
      await this.sortingService.setSortCriterion(criterion, direction);
    }

    const isClientSideOnly = criterion === SortCriterionEnum.Selected || criterion === SortCriterionEnum.List;
    if (!isClientSideOnly) {
      await this.applySortToServer(criterion, direction);
    }
  }

  async onSortDirectionClick(direction: SortDirectionEnum): Promise<void> {
    const criterion = this.currentSortState?.criterion || SortCriterionEnum.List;
    console.log('[onSortDirectionClick]:', criterion, direction);

    await this.sortingService.setSortCriterion(criterion, direction);

    if (criterion === SortCriterionEnum.List) {
      await this.applyListSortDirectionChangeToGrid(direction);
      return;
    }

    const isClientSideOnly = criterion === SortCriterionEnum.Selected;
    if (!isClientSideOnly) {
      await this.applySortToServer(criterion, direction);
    }
  }

  getCriterionLabel(criterion: SortCriterionEnum): string {
    return this.sortingService.getCriterionLabel(criterion, this.currentLayoutState);
  }

  shouldShowCriterionCheckmark(criterion: SortCriterionEnum): boolean {
    if (this.currentSortState?.criterion !== criterion) {
      return false;
    }
    if (this.isMobile && this.currentSortState?.source === SortSourceEnum.Layout) {
      return false;
    }
    return true;
  }

  shouldShowDirectionCheckmark(direction: SortDirectionEnum): boolean {
    if (this.currentSortState?.direction !== direction) {
      return false;
    }
    if (this.isMobile && this.currentSortState?.source === SortSourceEnum.Layout) {
      return false;
    }
    return true;
  }

  private async applySortToServer(criterion: SortCriterionEnum, direction: SortDirectionEnum): Promise<void> {
    console.log('[applySortToServer]:', criterion, direction);

    const updatedLayout = this.sortingService.updateLayoutStateWithTileSort(
      criterion,
      direction,
      this.currentLayoutState
    );
    await this.layoutStateService.setLayoutState(updatedLayout);

    const sortItems = this.convertUserStateToSortItems(updatedLayout);
    console.log('[applySortToServer] Calling setSorting with:', sortItems);
    await this.layoutStateService.setSorting(sortItems);
  }

  private async clearServerSort(): Promise<void> {

    const updatedLayout = this.sortingService.updateLayoutStateWithTileSort(
      SortCriterionEnum.List,
      SortDirectionEnum.Ascending,
      this.currentLayoutState
    );
    await this.layoutStateService.setLayoutState(updatedLayout);

    await this.layoutStateService.setSorting([]);
  }

  private convertUserStateToSortItems(userState: any): LayoutSortItem[] {
    const sortItems: LayoutSortItem[] = [];

    const fieldsDict: { [id: number]: Field } = {};
    (this.currentLayoutState?.layout?.Fields ?? []).map(f => fieldsDict[f.Field.Id] = f.Field);

    const layoutGroupingFields = (this.currentLayoutState?.layout?.Fields?.filter(x => x.Grouping !== 0) ?? []);

    for (const group of layoutGroupingFields) {
      const userField = userState?.Fields?.find((x: any) => fieldsDict[x.Field?.Id]?.DefaultName === group.Field.DefaultName);
      if (userField) {
        if ((userField.Grouping ?? 0) !== 0) {
          sortItems.push(new LayoutSortItem({
            Field: fieldsDict[userField.Field.Id],
            Direction: userField.IsDescending ? CoreSortDirectionEnum.Descending : CoreSortDirectionEnum.Ascending,
            IsGroupSorting: true
          }));
        }
      } else {
        sortItems.push(new LayoutSortItem({
          Field: group.Field,
          Direction: group.IsDescending ? CoreSortDirectionEnum.Descending : CoreSortDirectionEnum.Ascending,
          IsGroupSorting: true
        }));
      }
    }

    for (const field of (userState?.Fields ?? [])) {
      const g = layoutGroupingFields.find(x => field.Field?.Id === x.Field.Id);
      if (!g && (field.Grouping ?? 0) !== 0 && fieldsDict[field.Field?.Id]) {
        sortItems.push(new LayoutSortItem({
          Field: fieldsDict[field.Field.Id],
          Direction: field.IsDescending ? CoreSortDirectionEnum.Descending : CoreSortDirectionEnum.Ascending,
          IsGroupSorting: true
        }));
      }
    }

    if (userState?._structureSorting) {
      console.log('[convertUserStateToSortItems] Found Structure sorting:', userState._structureSorting);

      const structureField = new Field({
        DefaultName: 'Structure_DisplayPath'
      });

      const direction = userState._structureSorting.direction === SortDirectionEnum.Descending
        ? CoreSortDirectionEnum.Descending
        : CoreSortDirectionEnum.Ascending;

      console.log('[convertUserStateToSortItems] Structure direction:', direction);

      sortItems.push(new LayoutSortItem({
        Field: structureField,
        Direction: direction,
        IsGroupSorting: false
      }));

    }

    if (userState?._fieldSorting) {

      const sortField = new Field({
        DefaultName: userState._fieldSorting.defaultName
      });

      const direction = userState._fieldSorting.direction === SortDirectionEnum.Descending
        ? CoreSortDirectionEnum.Descending
        : CoreSortDirectionEnum.Ascending;


      sortItems.push(new LayoutSortItem({
        Field: sortField,
        Direction: direction,
        IsGroupSorting: false
      }));
    }

    if (userState?.Fields) {
      const sortedFields = userState.Fields
        .filter((f: any) => f.Sorting > 0)
        .sort((a: any, b: any) => a.Sorting - b.Sorting);

      for (const field of sortedFields) {
        const layoutField = fieldsDict[field.Field.Id];
        if (layoutField) {
          const direction = field.IsDescending ? CoreSortDirectionEnum.Descending : CoreSortDirectionEnum.Ascending;

          sortItems.push(new LayoutSortItem({
            Field: layoutField,
            Direction: direction,
            IsGroupSorting: false
          }));
        }
      }
    }

    return sortItems;
  }

  private async applyLayoutDefaultSorting(): Promise<void> {

    const { sortedFields, criterion, direction } = this.sortingService.getLayoutDefaultSorting(this.currentLayoutState);

    if (sortedFields.length === 0) {
      console.log('[Header] No layout sorting defined, clearing userState sorting');
      const emptyUserState = this.sortingService.updateLayoutStateWithTileSort(
        SortCriterionEnum.List,
        direction,
        this.currentLayoutState
      );
      await this.layoutStateService.setLayoutState(emptyUserState);
      await this.layoutStateService.setSorting([]);
      await this.sortingService.applyLayoutSorting(this.currentLayoutState);
      return;
    }

    const layoutFields = this.currentLayoutState?.layout?.Fields ?? [];
    const updatedUserState = JSON.parse(JSON.stringify(this.currentLayoutState?.userState ?? { Fields: [] }));
    if (!updatedUserState.Fields) {
      updatedUserState.Fields = [];
    }

    updatedUserState.Fields.forEach((f: any) => {
      f.Sorting = 0;
      f.IsDescending = false;
    });

    for (const sf of sortedFields) {
      let userField = updatedUserState.Fields.find((uf: any) => uf.Field?.Id === sf.fieldId);
      if (!userField) {
        const layoutField = layoutFields.find(lf => lf.Field?.Id === sf.fieldId);
        if (layoutField) {
          userField = {
            Field: { Id: sf.fieldId },
            Sorting: sf.sorting,
            IsDescending: sf.isDescending
          };
          updatedUserState.Fields.push(userField);
        }
      } else {
        userField.Sorting = sf.sorting;
        userField.IsDescending = sf.isDescending;
      }
    }

    await this.layoutStateService.setLayoutState(updatedUserState);
    const sortItems = this.convertUserStateToSortItems(updatedUserState);
    console.log('[Header] Applying layout default sort items:', sortItems);
    await this.layoutStateService.setSorting(sortItems);
    await this.sortingService.applyLayoutSorting(this.currentLayoutState);
  }

  private async applyListSortDirectionChangeToGrid(direction: SortDirectionEnum): Promise<void> {
    if (this.viewService.gridApi) {
      await this.colDefsService.updateAllSortedColumnsDirection(direction);
      return;
    }

    const layoutState = this.currentLayoutState;
    const userState = layoutState?.userState;
    if (!userState?.Fields || userState.Fields.length === 0) {
      console.warn('[Header] No userState fields to update for List direction change');
      return;
    }

    const updatedUserState = JSON.parse(JSON.stringify(userState));
    const sortedFields = updatedUserState.Fields.filter((f: any) => (f.Sorting ?? 0) > 0);
    if (sortedFields.length === 0) {
      console.warn('[Header] No sorted fields found in userState for List direction change');
      return;
    }
    const isDesc = direction === SortDirectionEnum.Descending;
    sortedFields.forEach((f: any) => { f.IsDescending = isDesc; });

    await this.layoutStateService.setLayoutState(updatedUserState);
    const sortItems = this.convertUserStateToSortItems(updatedUserState);
    await this.layoutStateService.setSorting(sortItems);
  }

  private async onFabButtonClick() {
    // if plan is open, directly show the dialog for create fault from plan
    if (this.faultsSplitService.rightViewVisible) {
      await this.createFaultFromPlan();
    }
  }

  private onPlanViewClose(rightViewVisibility: boolean) {
    if (!rightViewVisibility && this.deviceService.isTablet() && this.faultsSplitService.currentToggleValue === 'planView') {
      // set previous toggle view in button toggle group
      this.faultsSplitService.setRightViewVisble(false);
    }
  }

  // depends on device type returns floating action buttons objects
  private getFabButton( permissionAddAttachment: boolean, bimModel: boolean) {
    const fabButton: FloatingActionButton = {
      id: FloatButtonsTypesEnum.faultsView,
      floatingDisabled: false,
      iconName: 'add',
      tooltip: 'MM.fault.createFault',
      items: []
    };
    // if plan is open on table we remove sub item
    if (this.faultsSplitService.rightViewVisible) {
      return fabButton;
    }
    fabButton.items.push({
      id: MmFaultsViewHeaderComponent.mmCreateFromDescription,
      text: 'MM.fault.createFaultFromDescription',
      iconName: '_align-left',
    });

    if (permissionAddAttachment) {
      fabButton.items.push(
        {
          id: MmFaultsViewHeaderComponent.mmCreateFromFile,
          text: 'MM.fault.createFaultFromAttachment',
          iconName: !this.deviceService.isDesktop() ? 'photo_camera' : '_attach',
          iconOutlined: true
        });
    }

    fabButton.items.push({
      id: MmFaultsViewHeaderComponent.mmCreateFromPlan,
      text: 'MM.fault.createFaultFromPlan',
      iconName: '_plan-view'
    });

    if (bimModel && !this.deviceService.isMobil()) {
      fabButton.items.push({
        id: MmFaultsViewHeaderComponent.mmCreateFromBim,
        text: 'MM.fault.createFaultFromBIMmodel',
        iconName: '_bim-model'
      });
    }

    if (!this.deviceService.isMobil() && !(this.archiveSetting?.enabled ?? false)) {
      fabButton.items.push({
        id: MmFaultsViewHeaderComponent.mmCreateFromImport,
        text: 'MM.fault.createFaultFromImport',
        iconName: '_import'
      });
    }
    return fabButton;

  }


  private translateFabButton(fabButton: FloatingActionButton) {
    const translations = new Map([[MmFaultsViewHeaderComponent.mmCreateFromDescription, 'MM.fault.createFaultFromDescription'],
      [MmFaultsViewHeaderComponent.mmCreateFromFile, 'MM.fault.createFaultFromAttachment'],
      [MmFaultsViewHeaderComponent.mmCreateFromPlan, 'MM.fault.createFaultFromPlan'],
      [MmFaultsViewHeaderComponent.mmCreateFromBim, 'MM.fault.createFaultFromBIMmodel'],
      [MmFaultsViewHeaderComponent.mmCreateFromImport, 'MM.fault.createFaultFromImport'],
    ]);

    fabButton?.items?.forEach(value => {
      const key = translations.get(value.id);
      value.text = this.translateService.instant(key);
    });
  }

  private async stopSelectionMode() {
    if (!!(await firstValueFrom(this.selectionService.selectionMode))) {
      this.selectionService.stopSelectionMode();
    }
  }

  private onOfflineChanged(offline) {
    this.offline = offline;
    if (this.offline) {
      this.faultsSplitService.toggledLeftViews = ['tilesView'];
    }
  }

  private async onLocalModeChanged(isLocalMode: boolean) {
    this.initGroupToggleItems();
    if (isLocalMode) {
      if (this.faultsSplitService.toggledLeftViews?.includes('gridView')){
        this.notificationService.info(await firstValueFrom(this.translateService.get('MM.localMode.gridViewInfo')));
      }
      if (!this.mobilePlanViewService.activated) {
        this.faultsSplitService.toggledLeftViews = ['tilesView'];
        this.faultsSplitService.toggleView(this.headerToggleMenuEnum.tileView);
      }
    }
  }

  setNewRowLineAmount(amount: number) {
    this.rowDefsService.currentLineAmount = amount;
  }

  switchToGridView() {
    this.faultsSplitService.toggleView(HeaderToggleMenuEnum.gridView);
  }

  switchToTileView() {
    this.faultsSplitService.toggleView(HeaderToggleMenuEnum.tileView);
  }

  initGroupToggleItems() {
    this.gridViewToggleItem = {
      id: ToggleItemsIdEnum.GridView,
      icon: {
        name: 'view_headline',
        outlined: false,
        position: 'left',
      },
      readonly: this.platformModeStateService.isLocalMode,
      tooltip: this.translateService.instant('MM.fault.gridView'),
      matMenuRef: this.gridMultilineMatMenuRef
    };
    this.tileViewToggleItem = {
      id: ToggleItemsIdEnum.TileView,
      icon: {
        name: 'view_module',
        outlined: false,
        position: 'left',
      },
      readonly: false,
      tooltip: this.translateService.instant('MM.fault.tilesView'),
    };
    this.planViewToggleItem = {
      id: ToggleItemsIdEnum.PlanView,
      icon: {
        name: '_plan-view',
        outlined: false,
        position: 'left',
      },
      readonly: false,
      tooltip: this.translateService.instant('MM.fault.planView'),
    };
    this.bimViewToggleItem = {
      id: ToggleItemsIdEnum.BimView,
      icon: {
        name: '_bim-model',
        outlined: false,
        position: 'left',
      },
      readonly: false,
      tooltip: this.translateService.instant('MM.fault.bimView'),
    };

    const toggleItems = Object.values(ToggleItemsGroupEnum);

    for (let index = 0; index < toggleItems.length; index++) {
      const toggleItem = toggleItems[index];
      switch (toggleItem) {
        case ToggleItemsGroupEnum.First:
          this.toggleGroupItems1 = [this.gridViewToggleItem, this.tileViewToggleItem];
          break;
        case ToggleItemsGroupEnum.Second:
          this.toggleGroupItems2 = [this.planViewToggleItem];
          break;
        case ToggleItemsGroupEnum.Third:
          this.toggleGroupItems3 = [this.bimViewToggleItem];
          break;
      }
    }
  }

  syncLeftViewItemsWithToggleItems() {
    for (let i = 0; i < this.faultsSplitService?.toggledLeftViews?.length; i++) {
      const item = this.faultsSplitService.toggledLeftViews[i];
      switch (item) {
        // currently setting inital state only for the first group of toggle items
        case ToggleItemsIdEnum.GridView:
          this.selectedItem1 = this.gridViewToggleItem;
          break;
        case ToggleItemsIdEnum.TileView:
         this.selectedItem1 = this.tileViewToggleItem;
         break;
      }
    }
  }

  onGroupToggleItemClicked(item: ToggleGroupItem, group: ToggleItemsGroupEnum) {
    switch (group) {
      case ToggleItemsGroupEnum.First:
        this.selectedItem1 = item;
        break;
      case ToggleItemsGroupEnum.Second:
        if (item.id === ToggleItemsIdEnum.PlanView) {
          if (!this.faultsSplitService.toggledRightViews?.includes('planView')) {
            this.selectedItem2 = item;
          } else {
            this.selectedItem2 = null;
          }
        }
        break;
      case ToggleItemsGroupEnum.Third:
        // third button doesn't have a check state currently
        // this.selectedItem3 = item;
        break;
    }

    switch (item.id) {
      case ToggleItemsIdEnum.GridView:
        this.switchToGridView();
        break;
       case ToggleItemsIdEnum.TileView:
        this.switchToTileView();
        break;
        case ToggleItemsIdEnum.PlanView:
        this.faultsSplitService.toggleView(this.headerToggleMenuEnum.planView);
        break;
       case ToggleItemsIdEnum.BimView:
        this.bimDialogService.openBimDialog();
        break;
      default:
        break;
    }
  }
}
